// ============================================
// product-detail-specs.js — 產品詳情頁規格表渲染（對齊比較頁 10 項 + 劑型/字號）
// ============================================
// 角色：把詳情頁規格表（.product-specs-table tbody）由原本 5 列靜態硬編，改為「以比較頁
//   同一份資料（product-compare-items.js）渲染」，確保詳情頁與比較頁的規格逐項一致
//   （單一真相源＝比較資料）。
//
// 資料來源（決策 B）：COMPARE_PRODUCTS 找 id==='ha-juvederm'（本頁示範品 Juvederm 喬雅登），
//   取其 specs；列定義與標題用 COMPARE_SPEC_ROWS（10 項）。bool/badge/verified 值的渲染走
//   共用 compare-cell.js 的 renderCellValue → 與比較頁產出完全相同的 class（.compare-table__bool/
//   __check/__verified/__verified-label/__evidence + .badge--success/--info），CSS 一份共用。
//
// 列數＝10（比較項目）+ 2（詳情頁專屬：劑型、衛福部字號）＝12。劑型/字號為比較資料沒有、
//   但詳情頁該保留的兩列（決策 A），以純文字 append 在 10 列之後。
//
// 漸進增強：HTML tbody 預留固定高度（CSS min-height）避免 JS 填表時把下方「產品說明」往下推
//   （CLS）。無 JS 時表格為空（可接受——核心產品資訊在說明段與其他區塊；表格屬增強）。
//
// 由 src/main.js 中央 import 鏈載入（root 守門早退：找不到 [data-product-specs] 即 return，
//   非該頁不執行、不報錯）。同 product-detail.js / product-compare.js 慣例。
// ============================================

import { COMPARE_PRODUCTS, COMPARE_SPEC_ROWS } from '../data/product-compare-items.js';
import { renderCellValue, esc } from '../components/compare-cell.js';

const ROOT_SELECTOR = '[data-product-specs]';
// 本頁示範品在比較資料中的 id（與 product-compare-items.js 對齊）。
const PRODUCT_ID = 'ha-juvederm';

// 詳情頁專屬、比較資料沒有的兩列（決策 A：保留劑型 + 衛福部字號）。純文字。
// 字號為示例佔位（demo·待客戶後台補真實衛福部許可證字號），與 HTML 註解 / JSON-LD 同口徑。
const DETAIL_EXTRA_ROWS = [
  { label: '劑型', value: 'Voluma · Volift · Volbella' },
  { label: '衛福部字號', value: '衛署醫器製字第 001234 號（示例）' },
];

/** 單列 tr 字串：左 row-header（label）+ 右 cell（已渲染的值 HTML）。沿用 data-table class。 */
function buildRow(label, valueHtml) {
  return `<tr class="data-table__row">
        <th scope="row" class="data-table__cell product-specs-table__label">${esc(label)}</th>
        <td class="data-table__cell">${valueHtml}</td>
      </tr>`;
}

function init() {
  const tbody = document.querySelector(ROOT_SELECTOR);
  if (!tbody) return; // 非詳情頁 / 無此表 → 早退

  const product = COMPARE_PRODUCTS.find((p) => p.id === PRODUCT_ID);
  if (!product) return; // 資料缺示範品 → 不動表（保留 HTML 預留高度，不塞錯資料）

  // 10 項（比較頁同款）：label 取 COMPARE_SPEC_ROWS、值經 renderCellValue（bool/badge/verified）。
  const specRows = COMPARE_SPEC_ROWS.map((row) =>
    buildRow(row.label, renderCellValue(row, product.specs[row.key]))
  );

  // +2 詳情專屬列（純文字，esc 防護）。10 + 2 = 12 列。
  const extraRows = DETAIL_EXTRA_ROWS.map((r) => buildRow(r.label, esc(r.value)));

  // 批次 DOM：先組整串再單次 innerHTML（不在迴圈內 append）。
  tbody.innerHTML = specRows.concat(extraRows).join('');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
